import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyRateCard({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-14.6%"
          y="-10.4%"
          width="129.2%"
          height="129.2%"
          filterUnits="objectBoundingBox"
          id="pic-empty-rate-card_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-14.6%"
          y="-10.4%"
          width="129.2%"
          height="129.2%"
          filterUnits="objectBoundingBox"
          id="pic-empty-rate-card_svg__c"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-14.6%"
          y="-10.4%"
          width="129.2%"
          height="129.2%"
          filterUnits="objectBoundingBox"
          id="pic-empty-rate-card_svg__e"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <filter
          x="-14.6%"
          y="-10.4%"
          width="129.2%"
          height="129.2%"
          filterUnits="objectBoundingBox"
          id="pic-empty-rate-card_svg__g"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <circle id="pic-empty-rate-card_svg__b" cx={24} cy={24} r={24} />
        <circle id="pic-empty-rate-card_svg__d" cx={24} cy={24} r={24} />
        <circle id="pic-empty-rate-card_svg__f" cx={24} cy={24} r={24} />
        <circle id="pic-empty-rate-card_svg__h" cx={24} cy={24} r={24} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M174.9 147.5c-43.2 2.41-60.36 17.5-100.9 15.93-47.85-1.86-78.23-20.72-69.66-62.12C12.37 62.58 70 37 108 19c119.31-56.52 185.35 121.9 66.9 128.5z"
          fill="#E9EDFB"
        />
        <path
          d="M174.9 147.5c-38.25 1.52-55.1 16.03-98.21 16.03-26.57 0-85.29-8.93-71.83-63.98C47.43 142 239.12 59.1 237.26 93.7c-1.94 36.14-31.43 52.57-62.36 53.8z"
          fill="#8F9DD6"
          fillRule="nonzero"
          opacity={0.32}
        />
        <g transform="translate(91 60)">
          <circle fill="#6478CB" cx={29} cy={29} r={29} />
          <path
            d="M28.65 23.05l-8.4 6.92v9.11c0 .4.33.73.73.73l5.1-.01c.4 0 .73-.33.73-.73V34.7c0-.4.33-.73.73-.73h2.92c.4 0 .73.32.73.73v4.35a.73.73 0 00.73.73l5.1.02c.4 0 .73-.33.73-.73v-9.12l-8.4-6.91a.56.56 0 00-.7 0zm9.46 1.56V18.3c0-.3-.24-.55-.54-.55H35c-.3 0-.54.24-.54.55v3.3l-4.08-3.35a2.19 2.19 0 00-2.78 0l-11.54 9.5a.55.55 0 00-.07.77l1.16 1.41a.55.55 0 00.77.08l10.72-8.83c.2-.17.5-.17.7 0L40.07 30a.55.55 0 00.77-.08l1.16-1.4a.55.55 0 00-.08-.77l-3.8-3.14z"
            fill="#FFF"
          />
          <path
            d="M36.21 27.96a1.67 1.67 0 00-1.67 1.68v5.46c0 .43.17.84.48 1.14l6.77 6.77c.29.29.7.45 1.14.45.43 0 .85-.16 1.13-.45l5.53-5.53c.28-.28.45-.7.45-1.13 0-.43-.17-.85-.45-1.13l-6.69-6.7a1.67 1.67 0 00-1.26-.56z"
            stroke="#6478CB"
            strokeWidth={1.5}
            fill="#FFE266"
          />
          <path d="M38.47 30.62a1.27 1.27 0 100 2.54 1.27 1.27 0 000-2.54z" fill="#6478CB" />
        </g>
        <g transform="translate(126 12)">
          <use
            fill="#000"
            filter="url(#pic-empty-rate-card_svg__a)"
            xlinkHref="#pic-empty-rate-card_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-rate-card_svg__b" />
        </g>
        <path
          d="M157.9 35.39c.8 0 1.44.65 1.44 1.45v5.86a.64.64 0 01-.64.64h-.82a.64.64 0 01-.64-.64v-2.08h-14.48v2.08a.64.64 0 01-.64.64h-.82a.64.64 0 01-.64-.64v-5.86c0-.8.64-1.45 1.44-1.45zm-2.14-7.26c1.35 0 2.3.81 2.3 2.3v4.08h-3.78v-.72a1.96 1.96 0 00-1.96-1.96h-4.74c-1.08 0-1.96.88-1.96 1.96v.72h-3.67v-4.09c0-1.44.94-2.3 2.3-2.3z"
          fill="#56A"
          opacity={0.9}
        />
        <g transform="translate(158 88)">
          <use
            fill="#000"
            filter="url(#pic-empty-rate-card_svg__c)"
            xlinkHref="#pic-empty-rate-card_svg__d"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-rate-card_svg__d" />
        </g>
        <path
          d="M190.05 113.15c.8 0 1.44.64 1.44 1.44v5.46c0 .8-.65 1.44-1.44 1.44h-5.46c-.8 0-1.44-.65-1.44-1.44v-5.46c0-.8.64-1.44 1.44-1.44h5.46zm-10.5 0c.8 0 1.44.64 1.44 1.44v5.46c0 .8-.64 1.44-1.43 1.44h-5.47c-.79 0-1.43-.65-1.43-1.44v-5.46c0-.8.64-1.44 1.43-1.44h5.47zm9.78 2.16h-4.02v4.02h4.02v-4.02zm-10.5 0h-4.02v4.02h4.03v-4.02zm11.22-12.65c.8 0 1.44.64 1.44 1.43v5.47c0 .79-.65 1.43-1.44 1.43h-5.46c-.8 0-1.44-.64-1.44-1.43v-5.47c0-.79.64-1.43 1.44-1.43h5.46zm-9.98-.3c.5 0 .92.42.92.94v6.77c0 .5-.41.92-.92.92h-6.77a.93.93 0 01-.93-.92v-6.77c0-.52.41-.93.93-.93h6.77zm9.26 2.45h-4.02v4.03h4.02v-4.03z"
          fill="#56A"
          opacity={0.9}
        />
        <g transform="translate(41 102)">
          <use
            fill="#000"
            filter="url(#pic-empty-rate-card_svg__e)"
            xlinkHref="#pic-empty-rate-card_svg__f"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-rate-card_svg__f" />
        </g>
        <path
          d="M64.72 115.96h-.08c-.55 0-.93.35-.93.78l.18 4.68c.03.43-.49.78-.91.78-.4 0-.82-.33-.82-.73l-.06-4.78c0-.4-.44-.73-.98-.73h-.1c-.56 0-1.05.33-1.05.73l-.01 4.75c0 .4-.4.73-.8.73-.44 0-1-.35-1-.78l.2-4.67c.02-.43-.48-.78-1.02-.78h-.08c-.48 0-.97.32-1 .72l-.33 6.12c-.08 1.8 1.7 3.78 3.31 4.37l-.52 6.5a2.3 2.3 0 002.32 2.41 2.33 2.33 0 002.34-2.41l-.53-6.5c1.58-.56 3.3-2.57 3.25-4.37l-.3-6.1c-.02-.4-.57-.72-1.08-.72zm5.85 11.19l-.87 6.5c-.07.84.36 2.41 2.52 2.41 1.46 0 1.85-1.76 1.85-2.41V117.1c0-.64-.52-1.17-1.18-1.17-4.04 0-5.18 4.35-2.32 11.21z"
          fill="#56A"
          opacity={0.9}
        />
        <g transform="translate(47 26)">
          <use
            fill="#000"
            filter="url(#pic-empty-rate-card_svg__g)"
            xlinkHref="#pic-empty-rate-card_svg__h"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-rate-card_svg__h" />
        </g>
        <path
          d="M65.69 39.22c.15 0 .28.12.28.28v1.87h7.19V39.5c0-.16.12-.28.27-.28h1.6c.16 0 .28.12.28.28v1.87h1.48c.77 0 1.4.63 1.4 1.4v6.12a7.18 7.18 0 00-9.2 8.3h-6.66a1.4 1.4 0 01-1.4-1.4V42.77c0-.77.63-1.4 1.4-1.4h1.48V39.5c0-.16.13-.28.28-.28h1.6zm-4.75 8.2h17.25v-1.73H60.94v1.72zm15.1 14.08a5.75 5.75 0 100-11.5 5.75 5.75 0 000 11.5zm.93-6.23V53.2a.93.93 0 10-1.87 0v2.56c0 .3.14.58.38.76l2.1 1.52a.93.93 0 001.1-1.5l-1.71-1.26z"
          fill="#56A"
          opacity={0.9}
        />
      </g>
    </svg>
  );
}

SvgPicEmptyRateCard.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyRateCard.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyRateCard svgRef={ref} {...props} />
));
export default ForwardRef;
